export default __webpack_public_path__ + "static/media/arrow_back_ios1.fa0e12d2.svg";